import IComponent from "components/commons/IComponent";
import "./LayerSetting.scoped.css";
import EditableDatagridCell from "components/commons/EditableDatagridCell";
import MiniPanel from "components/commons/MiniPanel";
import Button from "@material-ui/core/Button";
import Layer2DList from "./Layer2DList";
import OverlayList from "./OverlayList";
import Manage3DLayer from "./Manage3DLayer";
import OpacitySlider from "./OpacitySlider";
import SearchUI from "./New3DLayerSetting/SearchUI";
import Layer3DList from "./Layer3DList";
import GetArcGISToken from "utils/GetArcGISToken";

class LayerSetting extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      showManage3DUI: false,
      showNew3DLayerSetting: false,
      showBIMModelDialog: false,
    };
  }
  componentDidMount() {}
  componentDidUpdate(prevProp) {
    if (prevProp.mapView != this.props.mapView) {
      console.debug("New view appear");
      this.props.mapView.watch(
        "updating",
        function(newV, oldV) {
          if (!newV) this.setState({});
        }.bind(this)
      );
    }
    if (prevProp.mapType !== this.props.mapType) {
      this.setState({ showManage3DUI: false });
    }
  }
  componentWillUnmount() {}

  closeNew3DLayerSetting() {
    this.setState({ showNew3DLayerSetting: false });
  }

  render() {
    console.debug("LayerSetting is updating");
    var vm = this;
    let { isSecondMap, isActiveOnly } = this.props;
    let layerList = this.$config[`mapList${isSecondMap ? "2" : ""}`];
    if (!layerList) return <div />;
    let basemapIdx = layerList.basemaps.findIndex((i) => i.layer.visible);
    basemapIdx = basemapIdx == -1 ? undefined : basemapIdx;
    let mapState = { basemapIdx };
    let showActiveItemOnly =
      typeof isActiveOnly !== "undefined" && isActiveOnly;
    return (
      <div className="LayerSettingContainer">
        {!("isSecondMap" in this.props) && (
          <div className="PanelTitle">
            <span>Layer Setting</span>
          </div>
        )}
        <div className="LayerListContainer">
          <div className="SubPanelContent">
            <div style={{ padding: "0px 0px 13px 0px" }}>Basemap</div>
            <EditableDatagridCell
              cellInfo={{
                row: mapState,
                colDef: {
                  required: true,
                  field: "basemapIdx",
                  dataType: "dropdown",
                  values: layerList.basemaps.map((i, j) => `${i.title}`),
                },
              }}
              onChange={(field, value, values) => {
                console.debug(value);
                vm.props.mapView.map.basemap.baseLayers.items.forEach(
                  (i, j) => {
                    i.visible = j == value;
                  }
                );
                vm.setState({});
              }}
              // style={{padding:"0px 20px 20px 20px"}}
            />
            <OpacitySlider
              layer={layerList.basemaps.find((i) => i.layer.visible)?.layer}
              onChange={(i) => (vm.props.mapView.map.ground.opacity = i)}
            />
          </div>
          <MiniPanel titleClass="ListTitle" titleText="Overlay">
            <OverlayList
              isSecondMap={isSecondMap}
              mapView={this.props.mapView}
              showActiveItem={showActiveItemOnly}
              showDialog={this.props.showDialog}
            />
          </MiniPanel>
          <MiniPanel titleClass="ListTitle" titleText="2D Map Layer">
            <Layer2DList
              isSecondMap={isSecondMap}
              mapView={this.props.mapView}
              showActiveItem={showActiveItemOnly}
              showDialog={this.props.showDialog}
            />
          </MiniPanel>
          {this.props.mapType == 3 && this.props.reduxStore.global.splitView && (
            <MiniPanel titleClass="ListTitle" titleText="3D Map Layer">
              <Layer3DList
                isSecondMap={isSecondMap}
                mapView={vm.props.mapView}
                showActiveItem={showActiveItemOnly}
                showDialog={this.props.showDialog}
              />
              <div className="SubPanelContent">
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => this.setState({ showManage3DUI: true })}
                  style={{ margin: "0px 0px 0px 20px", width: "90%" }}
                >
                  ALL 3D LAYER LIST
                </Button>
              </div>
            </MiniPanel>
          )}
          {this.props.mapType == 3 && !this.props.reduxStore.global.splitView && (
            <MiniPanel titleClass="ListTitle" titleText="3D Map Layer">
              <SearchUI
                isSecondMap={isSecondMap}
                mapView={vm.props.mapView}
                showActiveItem={showActiveItemOnly}
                showDialog={this.props.showDialog}
                reduxStore={this.props.reduxStore}
                reduxCallProxy={this.props.reduxCallProxy}
              />
              {(GetArcGISToken.user.isAdmin ||
                this.props.reduxStore.global.splitView) && (
                <div className="SubPanelContent">
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={() => this.setState({ showManage3DUI: true })}
                    style={{ margin: "0px 0px 0px 20px", width: "90%" }}
                  >
                    ALL 3D LAYER LIST
                  </Button>
                </div>
              )}
            </MiniPanel>
          )}
        </div>
        {this.state.showManage3DUI && (
          <Manage3DLayer
            mapView={this.props.mapView}
            isSecondMap={isSecondMap}
            onClose3DManagerCallback={() =>
              this.setState({ showManage3DUI: false })
            }
            showDialog={this.props.showDialog}
          />
        )}
      </div>
    );
  }
}

export default LayerSetting;
